module.exports = __webpack_public_path__ + "static/media/entry.800f921e.gif";